import { formatNumber } from '@agro1desenvolvimento/utils-js';
import { isEmpty } from 'lodash';
import {
  RecomendacaoSemeaduraRegulagem,
  RecomendacaoSemeaduraResumoRegulagem,
  TalhaoRow,
  UnidadeConversao,
} from '../../../../@types';
import { UnidadesService } from '../../../../services';

const NUMBER_FORMAT_OPTIONS = {
  maximumFractionDigits: 2,
  useGrouping: true,
};

export const getTotalLabel = (
  value: number,
  unidade: UnidadeConversao | null,
) => {
  const unidadeTaxa = unidade ? UnidadesService.getTaxaFinal(unidade) : 1;
  const unidadeAbreviatura = unidade?.abreviatura || 'kg';

  const valueFormatted = formatNumber(
    value / unidadeTaxa,
    NUMBER_FORMAT_OPTIONS,
  );

  return `${valueFormatted} ${unidadeAbreviatura}`;
};

export const defaultNumberFormatter = (value: number) =>
  formatNumber(value, NUMBER_FORMAT_OPTIONS);

const formatRegulagem = (value: number) =>
  formatNumber(value, {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
    useGrouping: true,
  });

const getFormattedRegulagem = ({
  comMargemSeguranca,
  regulagem,
}: {
  comMargemSeguranca: boolean;
  regulagem: RecomendacaoSemeaduraRegulagem;
}) => {
  if (comMargemSeguranca) {
    const regulagemMinima = formatRegulagem(Math.floor(regulagem.min));
    const regulagemMaxima = formatRegulagem(Math.floor(regulagem.max));

    return `${regulagemMinima} a ${regulagemMaxima}`;
  }

  return formatRegulagem(regulagem.result);
};

export const getRegulagem = (
  data: TalhaoRow,
  regulagem: RecomendacaoSemeaduraRegulagem,
  comMargemSeguranca: boolean,
): RecomendacaoSemeaduraResumoRegulagem => {
  const unidadeAbreviatura = 'g';

  const regulagemCalculada = getFormattedRegulagem({
    comMargemSeguranca,
    regulagem,
  });

  const pms = data.pms || 0;

  const getRegulagemConvertida = (value: number) => (value * pms) / 1000;

  if (comMargemSeguranca) {
    const minima = getRegulagemConvertida(regulagem.min);
    const maxima = getRegulagemConvertida(regulagem.max);

    const intervaloRegulagem = `${formatRegulagem(minima)} a ${formatRegulagem(
      maxima,
    )}`;

    return {
      calculada: regulagemCalculada,
      intervalo: intervaloRegulagem,
      resultado: '0',
      unidade: unidadeAbreviatura,
    };
  }

  const resultadoConvertido = formatRegulagem(
    getRegulagemConvertida(regulagem.result),
  );

  return {
    calculada: regulagemCalculada,
    intervalo: '0',
    resultado: resultadoConvertido,
    unidade: unidadeAbreviatura,
  };
};

export const getPeriodo = (
  dataInicio: Date | null,
  dataTermino: Date | null,
  area: number,
  rendimentoOperacionalMaximo: number,
  rendimentoOperacionalMinimo: number,
) => {
  if (!dataInicio || !dataTermino) return '';

  const duracaoMinima =
    rendimentoOperacionalMaximo > 0
      ? formatNumber(area / rendimentoOperacionalMaximo, NUMBER_FORMAT_OPTIONS)
      : '';

  const duracaoMaxima =
    rendimentoOperacionalMinimo > 0
      ? formatNumber(area / rendimentoOperacionalMinimo, NUMBER_FORMAT_OPTIONS)
      : '';

  const duracao =
    rendimentoOperacionalMinimo > 0
      ? `${duracaoMinima} a ${duracaoMaxima}`
      : duracaoMinima || duracaoMaxima;

  return isEmpty(duracao) ? '0 a 0' : ` ${duracao}`;
};
